import classNames from 'classnames';

export interface TableHeadProps {
  className?: string;
}

export function TableHead({ className, children }: React.PropsWithChildren<TableHeadProps>) {
  return <thead className={classNames('bg-surface-elevated dark:bg-gray-700', className)}>{children}</thead>;
}

export default TableHead;
